import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';

import styles from './modal.scss';

interface Props {
  showModal: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
}

export const WarningEliminationsGroupModal = ({ showModal, handleClose, handleSubmit }: Props) => {
  const intl = useIntl();

  return (
    <Dialog
      open={showModal}
      onCancel={handleClose}
      size="medium-small"
      title={intl.formatMessage({ id: 'common.warning', defaultMessage: 'Warning!' })}
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={handleClose}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button onClick={handleSubmit} buttonType="primary">
            <FormattedMessage id="common.continue" defaultMessage="Continue" />
          </Button>
        }
        onSubmit={handleSubmit}
      >
        <p className={styles.text} style={{ padding: '0 12px' }}>
          <FormattedMessage
            id="consolidation.warning_eliminations_group_desc"
            defaultMessage="Eliminations and elimination groups will not be saved if you continue."
          />
        </p>
      </Form>
    </Dialog>
  );
};
